import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { LoginService, Configuration, TokenResponse } from 'generated-sources/openapi';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, HttpInterceptor {
  lastCheck: number;
  result;
  isAdmin = false;

  tokenSubject = new BehaviorSubject<TokenResponse>(null);
  token$ = this.tokenSubject.asObservable();

  constructor(private loginService: LoginService, private cfg: Configuration, protected router: Router) {
    this.init();
  }

  init(): void {
    let tokens: TokenResponse = null;
    try {
      const s = window.localStorage.getItem('login');
      if (s) {
        tokens = JSON.parse(s);
      }
    } catch (err) {

    }
    this.updateToken(tokens);
  }

  updateToken(token: TokenResponse): void {
    this.isAdmin = token ? token.role === 'admin' : false;
    this.tokenSubject.next(token);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    console.log('ag intercept', req);
    return next.handle(req).pipe(tap((event) => { }, (event) => {
      if (event instanceof HttpErrorResponse) {
        console.log('auth g', event);
        if (event.status === 401) {
          // TODO: Attempt to refresh token
          window.localStorage.removeItem('login');
          this.cfg.accessToken = null;
          this.lastCheck = 0;
          this.updateToken(null);


          // IF refresh fails.
          this.router.navigate(['/login']);
        } else if (event.status === 403) {
          this.router.navigate(['/not-admin']);
        }
      }
    }));
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('in guard can activate');
    let token = this.cfg.accessToken;
    if (typeof token === 'function') {
      token = token();
    }
    if (token) {
      // TODO: validate access token
      return true;
    } else {
      this.updateToken(null);
      this.router.navigate(['/login']);
      return false;
    }
  }

}


@Injectable()
export class AdminGuard extends AuthGuard implements CanActivate, HttpInterceptor {
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const unknownresult = super.canActivate(next, state);
    if (unknownresult === true) {
      if (!this.isAdmin) {
        // FIXME: FAIL
        this.router.navigate(['/not-admin']);
      } else {
        return true;
      }
    } else {
      return unknownresult;
    }
  }
}
